import { render } from "./printNoFrom.vue?vue&type=template&id=980d2c18&scoped=true"
import script from "./printNoFrom.vue?vue&type=script&lang=js"
export * from "./printNoFrom.vue?vue&type=script&lang=js"

import "./printNoFrom.vue?vue&type=style&index=0&id=980d2c18&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980d2c18"]])

export default __exports__